import { createPortal } from 'react-dom';
import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { useFramePortalContainer } from '../hooks/useFramePortalContainer';
import { stringify } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getClipEditorEmbedBaseUrl = projectId => {
  const fullUrl = getFullUrl(enviro.deployed() ? 'app' : 'local');
  const portalId = PortalIdParser.get();
  let params = {
    detailsPage: 'new',
    referrerApp: undefined
  };
  try {
    const referrerApp = window.hubspot.bender.currentProject;
    params = Object.assign({}, params, {
      referrerApp
    });
    if (referrerApp) {
      return `${fullUrl}/content-clip-editor/${portalId}/iframe/project/${projectId}?${stringify(params)}`;
    } else {
      throw new Error('No referrer app found');
    }
  } catch (_unused) {
    return `${fullUrl}/content-clip-editor/${portalId}/iframe/project/${projectId}?${stringify(params)}`;
  }
};
export const frameName = 'clip-editor-iframe';
export const ClipEditorIframe = ({
  isActive,
  projectId,
  isLoading
}) => {
  const portalContainerRef = useFramePortalContainer();
  if (isActive && !projectId) {
    // TODO - consider fallback behavior if project ID is not found
    console.error('No project ID found when rendering active ClipEditorIframe');
    return null;
  }
  const iframeContent =
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsxs("div", {
    "data-test-id": "clip-editor-iframe-wrapper",
    style: {
      display: isActive ? 'block' : 'none',
      position: 'fixed',
      top: 0,
      right: 0,
      width: '100%',
      height: '100%',
      zIndex: 11112,
      border: 'none'
    },
    children: [isLoading && /*#__PURE__*/_jsx(LoadingOverlay, {
      size: "medium"
    }), /*#__PURE__*/_jsx("iframe", {
      style: {
        width: '100%',
        height: '100%',
        border: 'none'
      },
      height: "100%",
      width: "100%",
      name: frameName,
      src: projectId ? getClipEditorEmbedBaseUrl(projectId) : ''
    })]
  });

  // Portal render into body-attached div
  return portalContainerRef.current ? /*#__PURE__*/createPortal(iframeContent, portalContainerRef.current) : null;
};